module.exports = __webpack_public_path__ + "img/tick-mark-white.7bf3fffd.svg";